import { Box, MenuItem, Select } from '@material-ui/core'
import { Button } from 'components/facets'

interface TablePaginationControlsProps {
  currentPage: number
  setPage: (newPage: number) => void
  isLastPage?: boolean // Otional: use to disable "Next"
  startFromZero: boolean
  // Optional: turns the page number into a select to jump to any page, followed by "/ total"
  totalPages?: number
  // The total is only a lower bound (the server stopped counting)
  totalPagesCapped?: boolean
}

export const TablePaginationControls = ({
  currentPage,
  setPage,
  isLastPage = false,
  startFromZero,
  totalPages,
  totalPagesCapped = false,
}: TablePaginationControlsProps) => {
  const handlePrevPage = () => setPage(Math.max(currentPage - 1, 0))
  const handleNextPage = () => {
    setPage(currentPage + 1)
  }

  const displayedPage = startFromZero ? currentPage + 1 : currentPage

  return (
    <Box mt={2} display="flex" justifyContent="center" alignItems="center">
      <Button
        variant="contained"
        onClick={handlePrevPage}
        disabled={currentPage === 0 || (currentPage === 1 && !startFromZero)}
        style={{ minWidth: '40px', padding: '6px' }}
      >
        <i className="fa-regular fa-chevron-left"></i>
      </Button>
      <Box alignSelf="center" className="mx-3">
        {totalPages !== undefined && totalPages > 1 ? (
          <>
            <Select
              value={displayedPage}
              onChange={(e) => {
                const page = Number(e.target.value)
                setPage(startFromZero ? page - 1 : page)
              }}
              inputProps={{ 'aria-label': 'Page' }}
            >
              {/* Past the capped total the arrows still move on; keep that page selectable */}
              {Array.from({ length: Math.max(totalPages, displayedPage) }, (_, i) => (
                <MenuItem key={i + 1} value={i + 1}>
                  {i + 1}
                </MenuItem>
              ))}
            </Select>{' '}
            / {totalPages}
            {totalPagesCapped ? '+' : ''}
          </>
        ) : (
          <>
            {/* Display pages starting from 1 instead of  0 */}
            {displayedPage}
            {totalPages !== undefined && ` / ${totalPages}`}
          </>
        )}
      </Box>
      <Button
        variant="contained"
        onClick={handleNextPage}
        disabled={isLastPage}
        style={{ minWidth: '40px', padding: '6px' }}
      >
        <i className="fa-regular fa-chevron-right"></i>
      </Button>
    </Box>
  )
}
